// pages/LuxotticaUnauthorizedPage.jsx
import { useNavigate } from 'react-router-dom';
import UnauthorizedPage from '@/components/UnauthorizedPage';
import { useAuth } from '@/contexts/AuthContext';

const LuxotticaUnauthorizedPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <UnauthorizedPage
      projectName="Luxottica"
      onGoToDashboard={() => navigate('/')}
      // Must sign out of Logto rather than just visit /login: the session is
      // still valid, so /login would redirect straight back here.
      onSignInDifferent={() => logout()}
      brandColor="blue"
    />
  );
};

export default LuxotticaUnauthorizedPage;
